var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.412472 4.72559L5.03776 0.113083C5.1893 -0.0379512 5.43465 -0.0376973 5.58594 0.113865C5.73711 0.265407 5.73672 0.510894 5.58516 0.662046L1.23518 5.00002L5.58532 9.33797C5.73686 9.48914 5.73725 9.73447 5.5861 9.88603C5.51026 9.96201 5.4109 10 5.31155 10C5.21245 10 5.11348 9.96226 5.03778 9.88682L0.412472 5.27443C0.339484 5.20181 0.298527 5.10299 0.298527 5.00002C0.298527 4.89705 0.339602 4.79834 0.412472 4.72559Z",
    fill: "current"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron-left.5cb022c7.svg";
export { ForwardRef as ReactComponent };